import { DatePicker, Space, TreeSelect } from "antd";
import { TreeNode } from "antd/lib/tree-select";
import Axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import TableComponent from "../../../../_metronic/table/TableComponent";

const dateFormat = "YYYY-MM-DD";

const headers = [
  { label: "Category name", key: "category_name" },
  { label: "Total Discount", key: "totalDiscount" },
  { label: "Total kg", key: "totalKg" },
  { label: "Total Orders", key: "totalOrders" },
  { label: "Total purchased value", key: "totalValuePurchased" },
  { label: "Volume Quantity", key: "volumeQty" },
];

const CategoryTreeBased = () => {
  const {
    user: { accessToken, refreshToken },
  } = useSelector((state) => state.auth);
  const [productBaseCategory, setBaseProductCategory] = useState([]);
  const [date_from, setDate_from] = useState(
    moment()
      .startOf("month")
      .format(dateFormat)
  );
  const [date_to, setDate_to] = useState(
    moment()
      .endOf("month")
      .format(dateFormat)
  );
  const [categorywiseSalesList, setCategorywiseSalesList] = useState([]);
  const [category, setCategory] = useState();

  // 1- API Get Product Category
  const getProductCategory = async () => {
    await Axios.get(
      `${process.env.REACT_APP_API_URL}/product-category/getProductCategoryListForB2C`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    ).then((res) => {
      if (res.data?.length > 0) {
        setBaseProductCategory(res.data);
      }
    });
  };

  const submitData = async () => {
    let searchData = {
      type: "B2C",
      start_date: moment(date_from).format(dateFormat),
      end_date: moment(date_to).format(dateFormat),
      category_id: category,
    };

    const { data, status } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/report/subCategoryWiseSalesSingle`,
      searchData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    if (status == 404 || status == 204) {
      swal({
        title: "No data Found",
        icon: "info",
      });
    } else if (!data.error) {
      if (data.data.length) {
        setCategorywiseSalesList(data.data);
        console.log(data.data);
      } else {
        setCategorywiseSalesList([]);
      }
    } else {
      swal({
        title: data.message,
        icon: "info",
      });
    }
  };

  // React Table
  const data = React.useMemo(() => categorywiseSalesList, [
    categorywiseSalesList,
  ]);

  const columns = React.useMemo(() => [
    {
      Header: "#",
      accessor: (row, index) => (
        <div className="d-flex align-items-center pl-4">
          <div>
            <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
              {index + 1}
            </h4>
          </div>
        </div>
      ),
      minWidth: 50,
      width: 50,
    },
    {
      Header: "Category name",
      accessor: "category_name",
      width: 200,
      paddingLeft: "0px",
    },

    {
      Header: "Total discount",
      accessor: "totalDiscount",
      paddingLeft: "0px",
    },

    {
      Header: "Total kg",
      accessor: "totalKg",
      paddingLeft: "0px",
    },
    {
      Header: "Total orders",
      accessor: "totalOrders",
      paddingLeft: "0px",
    },
    {
      Header: "Total purchased value",
      accessor: "totalValuePurchased",
      width: 200,
      paddingLeft: "0px",
    },
    {
      Header: "Volume quantity",
      accessor: "volumeQty",
      paddingLeft: "0px",
    },
  ]);

  useEffect(() => {
    getProductCategory();
  }, []);

  return (
    <div>
      <div className="card custom-custom py-5 mb-10">
        <div className="card-header border-0 d-flex justify-content-between pb-0">
          <h3 className="card-title mb-5">category-tree-based-reports</h3>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-3 mb-5">
              <label>Select Category*</label>
              <TreeSelect
                showSearch
                style={{ width: "100%" }}
                // value={selectedBaseCategory}
                dropdownStyle={{
                  maxHeight: 400,
                  overflow: "auto",
                }}
                placeholder="Please select"
                allowClear
                treeDefaultExpandAll
                onChange={async (value) => {
                  setCategory(value);
                }}
              >
                {productBaseCategory.map((category) => (
                  <TreeNode value={category.value} title={category.label}>
                    {category.children &&
                      category.children.map((child1) => (
                        <TreeNode value={child1.value} title={child1.label}>
                          {child1.children &&
                            child1.children.map((child2) => (
                              <TreeNode
                                value={child2.value}
                                title={child2.label}
                              ></TreeNode>
                            ))}
                        </TreeNode>
                      ))}
                  </TreeNode>
                ))}
              </TreeSelect>
            </div>
            <div className="col-md-3">
              <div
                className="d-flex"
                style={{
                  flexDirection: "column",
                }}
              >
                <label>
                  {" "}
                  Start Date
                  <span className="text-danger">*</span>
                </label>
                <Space direction="vertical" size={12}>
                  <DatePicker
                    style={{
                      width: "100%",
                      marginRight: "10px",
                    }}
                    format={dateFormat}
                    placeholder="MM/DD/YYYY"
                    defaultValue={moment(date_from)}
                    onChange={(date, dateString) => setDate_from(dateString)}
                  />
                </Space>
              </div>
            </div>
            <div className="col-md-3">
              <div
                className="d-flex"
                style={{
                  flexDirection: "column",
                }}
              >
                <label>
                  {" "}
                  End Date
                  <span className="text-danger">*</span>
                </label>
                <Space direction="vertical" size={12}>
                  <DatePicker
                    style={{
                      width: "100%",
                      marginRight: "10px",
                    }}
                    format={dateFormat}
                    placeholder="MM/DD/YYYY"
                    defaultValue={moment(date_to)}
                    onChange={(date, dateString) => setDate_to(dateString)}
                  />
                </Space>
              </div>
            </div>
            <div className="col-md-3 mt-4">
              <button
                onClick={() => {
                  submitData();
                }}
                className="btn btn-primary w-75 mt-5"
              >
                search
              </button>
            </div>
          </div>

          {categorywiseSalesList?.length > 0 && (
            <TableComponent
              columns={columns}
              data={data}
              hideAddButton={true}
              lists={categorywiseSalesList}
              csv={true}
              excelHeader={headers}
              filename={"Categorywise Sales.csv"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryTreeBased;
